import React from 'react';
import { useTranslation } from 'react-i18next';
import { FullBiddingDataFragment } from '../../../../../api';
import Accordion from '../../../../../components/Accordion';
import EditSessionForm from '../../Forms/EditSessionForm';

export type EditSessionAccordionProps = {
    bidding: FullBiddingDataFragment;
};

const EditSessionAccordion = ({ bidding }: EditSessionAccordionProps) => {
    const { t } = useTranslation(['biddingSessionsPage']);

    return (
        <Accordion title={t('biddingSessionsPage:editTitle')} defaultExpanded>
            <EditSessionForm bidding={bidding} />
        </Accordion>
    );
};

export default EditSessionAccordion;
